import axios from '../../services/axios.service';
import { getEndpointBase } from '../../services/api.service';

const employeeService = {
  getList: ({ group, search, page, ...params }: any) => {
    return axios.get(getEndpointBase('employees'), {
      params: {
        keywords: search,
        page,
        filter: {
          ...params,
          ...group
        },
      },
    });
  },
};

export default employeeService;
